import Service from './Service';

export default class Partner extends Service {

  listByCompany() {
    return this.axiosInstance.get(`/partners/company`);
  }

  listByGroup() {
    return this.axiosInstance.get(`/partners/group`);
  }

  listAllByCompany({tag}) {
    return this.axiosInstance.get(`/partners/all${tag? '?tag=' + tag:''}`);
  }

  listBySearch({ search, limit, categoryList, tag, partner }) {
    return this.axiosInstance.get(`/partners/search?limit=${limit}${search ? '&search=' + search : ''}${categoryList ? '&categoryList=' + categoryList : ''}${tag ? '&tag=' + tag : ''}${partner ? '&partner=' + partner : ''}`);
  }

  findByID({ partnerID }) {
    return this.axiosInstance.get(`/partners/${partnerID}`);
  }

}
